<template>
    <div class="form-item">
        <label class="label-caption">Tipo Grupo</label>
        <select :value="tipoSelecionado" @change="atualizarTipo" class="form-control" v-bind="$attrs">
            <option v-for="tipo in tiposGrupoEquipamento" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
        </select>
    </div>
</template>
  
<script>
export default {
    props: {
        tipoSelecionado: {type: Number, default: null}
    },

    data() {
        return{
            tiposGrupoEquipamento:[
                {id: 0, descricao: 'MÁQUINAS'},
                {id: 1, descricao: 'PROFISSIONAIS'},
                {id: 2, descricao: 'VEÍCULOS'}
            ]
        };
    },

    methods: {
        atualizarTipo(event) {
            this.$emit('update:tipoSelecionado', Number(event.target.value));
        }
    }
};
</script>